/* eslint-disable max-len */
/* eslint-disable max-lines */

export enum ApprovalStatus {
  PENDING = 1,
  APPROVED,
  REJECTED,
  DISCREDITED,
  AWAITING_FORMALIZATION,
  FORMALIZATION_SUBMITTED,
}

export enum ApprovalStatusLabel {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  DISCREDITED = 'discredited',
  AWAITING_FORMALIZATION = 'awaiting_formalization',
  FORMALIZATION_SUBMITTED = 'formalization_submitted',
}

export const convertApprovalStatus = (
  approvalStatus: ApprovalStatus
): string => {
  let word = '';
  switch (approvalStatus) {
    case ApprovalStatus.PENDING:
      word = 'em análise';
      break;
    case ApprovalStatus.APPROVED:
      word = 'ativo';
      break;
    case ApprovalStatus.REJECTED:
      word = 'rejeitada';
      break;
    case ApprovalStatus.DISCREDITED:
      word = 'descredenciado';
      break;
    case ApprovalStatus.AWAITING_FORMALIZATION:
      word = 'aguardando formalização';
      break;
    case ApprovalStatus.FORMALIZATION_SUBMITTED:
      word = 'formalização em análise';
      break;
    default:
      word = '';
  }
  return word;
};

export enum ArchivedReason {
  FINISHED = 1,
  CANCELED,
}

export const convertArchivedReason = (
  archivedReason: ArchivedReason | undefined | null
): string => {
  let word = '';
  switch (archivedReason) {
    case ArchivedReason.FINISHED:
      word = 'finalizado';
      break;
    case ArchivedReason.CANCELED:
      word = 'cancelado';
      break;
    default:
      word = '';
  }
  return word;
};

export enum ClientKind {
  SELECT,
  CORPORATE = 1,
  LANDING = 3,
  BRASIL_BANK = 2,
  CAIXA = 4,
  ITAU = 8,
  BRADESCO,
  SANTANDER,
  NORDESTE,
  BRB,
  BANESTES,
  AMAZONIA,
  BANPARA,
  BANRISUL,
  POUPEX,
  BANCO_INTER,
  C6_BANK,
  SICOOB,
  BNB = 21,
  INSPECTION = 6,
  OTHER_BANK = 5,
}

export const convertClientKind = (clientKind: ClientKind): string => {
  let word = '';
  switch (clientKind) {
    case ClientKind.SELECT:
      word = 'selecione uma opção';
      break;
    case ClientKind.CORPORATE:
      word = 'empresarial';
      break;
    case ClientKind.LANDING:
      word = 'particular';
      break;
    case ClientKind.BRASIL_BANK:
      word = 'Banco do Brasil';
      break;
    case ClientKind.CAIXA:
      word = 'Caixa';
      break;
    case ClientKind.ITAU:
      word = 'Itaú';
      break;
    case ClientKind.BRADESCO:
      word = 'Bradesco';
      break;
    case ClientKind.SANTANDER:
      word = 'Santander';
      break;
    case ClientKind.NORDESTE:
      word = 'Banco do Nordeste';
      break;
    case ClientKind.BRB:
      word = 'Banco BRB';
      break;
    case ClientKind.BANESTES:
      word = 'Banestes';
      break;
    case ClientKind.AMAZONIA:
      word = 'Banco da Amazônia';
      break;
    case ClientKind.BANPARA:
      word = 'Banpará';
      break;
    case ClientKind.BANRISUL:
      word = 'Banrisul';
      break;
    case ClientKind.POUPEX:
      word = 'Poupex';
      break;
    case ClientKind.BANCO_INTER:
      word = 'Banco Inter';
      break;
    case ClientKind.C6_BANK:
      word = 'C6 Bank';
      break;
    case ClientKind.SICOOB:
      word = 'Sicoob';
      break;
    case ClientKind.BNB:
      word = 'BNB';
      break;
    case ClientKind.INSPECTION:
      word = 'Vistoria';
      break;
    case ClientKind.OTHER_BANK:
      word = 'outros bancos';
      break;
    default:
      word = '';
  }
  return word;
};

export enum Concept {
  SELECT,
  URBAN,
  RURAL,
}

export const convertConcept = (enumType: Concept): string => {
  let word: string;
  switch (enumType) {
    case Concept.SELECT:
      word = 'selecione uma opção';
      break;
    case Concept.URBAN:
      word = 'urbano';
      break;
    case Concept.RURAL:
      word = 'rural';
      break;
    default:
      word = '';
  }
  return word;
};

export enum ConservationState {
  SELECT,
  NEW,
  NEWREGULAR,
  REGULAR,
  REGULARREPAIR,
  EASYREPAIR,
  REPAIREASYBIG,
  BIGREPAIR,
  REPAIRBIGNOVALUE,
  NOVALUE,
}

export const convertConservationState = (
  enumType: ConservationState
): string => {
  let word: string;
  switch (enumType) {
    case ConservationState.SELECT:
      word = 'selecione uma opção';
      break;
    case ConservationState.NEW:
      word = 'novo';
      break;
    case ConservationState.NEWREGULAR:
      word = 'entre novo e regular';
      break;
    case ConservationState.REGULAR:
      word = 'regular';
      break;
    case ConservationState.REGULARREPAIR:
      word = 'regular à reparos simples';
      break;
    case ConservationState.EASYREPAIR:
      word = 'reparos simples';
      break;
    case ConservationState.REPAIREASYBIG:
      word = 'reparos simples à importantes';
      break;
    case ConservationState.BIGREPAIR:
      word = 'reparos importantes';
      break;
    case ConservationState.REPAIRBIGNOVALUE:
      word = 'reparos importantes à edificação sem valor';
      break;
    case ConservationState.NOVALUE:
      word = 'sem valor';
      break;
    default:
      word = '';
  }
  return word;
};

export enum CubPropertyType {
  SELECT,
  HOUSE,
  APARTMENT,
  FREEFLOOR,
  ROOMS_AND_STORES,
  INDUSTRIAL,
  STORE,
  WAREHOUSE,
  COMMERCIAL_BUILDING,
  COMMERCIAL_ROOM,
}

export const convertCubPropertyType = (enumType: CubPropertyType): string => {
  let word: string;
  switch (enumType) {
    case CubPropertyType.SELECT:
      word = 'selecione uma opção';
      break;
    case CubPropertyType.HOUSE:
      word = 'Casa';
      break;
    case CubPropertyType.APARTMENT:
      word = 'Apartamento';
      break;
    case CubPropertyType.FREEFLOOR:
      word = 'Andar Livre';
      break;
    case CubPropertyType.ROOMS_AND_STORES:
      word = 'Salas e Lojas';
      break;
    case CubPropertyType.INDUSTRIAL:
      word = 'Industrial';
      break;
    case CubPropertyType.STORE:
      word = 'Loja';
      break;
    case CubPropertyType.WAREHOUSE:
      word = 'Galpão';
      break;
    case CubPropertyType.COMMERCIAL_BUILDING:
      word = 'Prédio Comercial';
      break;
    case CubPropertyType.COMMERCIAL_ROOM:
      word = 'Sala Comercial';
      break;
    default:
      word = '';
  }
  return word;
};

export enum EvaluationType {
  SELECT,
  AUTOFACTORS,
  AUTOINFERENCES,
  SIMPFACTORS,
  SIMPINFERENCES,
  COMPLETEFACTORS,
  COMPLETEINFERENCES,
  EVOLUTIVE,
  INVOLUTIVE,
}

export const convertEvaluationType = (
  evaluationType: EvaluationType
): string => {
  let word: string;
  switch (evaluationType) {
    case EvaluationType.SELECT:
      word = 'selecione uma opção';
      break;
    case EvaluationType.AUTOFACTORS:
      word = 'Automático - Fatores';
      break;
    case EvaluationType.AUTOINFERENCES:
      word = 'Automático - Inferência';
      break;
    case EvaluationType.SIMPFACTORS:
      word = 'Simplificado - Fatores';
      break;
    case EvaluationType.SIMPINFERENCES:
      word = 'Simplificado - Inferência';
      break;
    case EvaluationType.COMPLETEFACTORS:
      word = 'Completo - Fatores';
      break;
    case EvaluationType.COMPLETEINFERENCES:
      word = 'Completo - Inferência';
      break;
    case EvaluationType.EVOLUTIVE:
      word = 'Completo - Evolutivo';
      break;
    case EvaluationType.INVOLUTIVE:
      word = 'Completo - Involutivo';
      break;
    default:
      word = '';
  }
  return word;
};

export enum EvaluationTypeBank {
  SELECT,
  SIMPINFERENCES = 4,
}

export const convertEvaluationTypeBank = (
  evaluationType: EvaluationTypeBank
): string => {
  let word: string;
  switch (evaluationType) {
    case EvaluationTypeBank.SELECT:
      word = 'selecione uma opção';
      break;
    case EvaluationTypeBank.SIMPINFERENCES:
      word = 'Simplificado - Inferência';
      break;
    default:
      word = '';
  }
  return word;
};

/**
 * Papéis do usuário (campo `role` da empresa no JWT). Espelha o enum canônico
 * `Role` do backend (1–18). `SELECT = 0` é apenas placeholder de UI.
 * O gating de RBAC (REAL-3099) usa este `role`, nunca `additional_roles`.
 */
export enum ProfileUsers {
  SELECT = 0,
  ARCHITECT = 1,
  ENGINEER = 2,
  ADMIN = 3,
  CORPORATE = 4,
  BANCO = 5,
  LANDING = 6,
  COMERCIAL = 7,
  FINANCEIRO = 8,
  CORRETOR = 9,
  BANK_ADMIN = 10,
  BANK_FINANCEIRO = 11,
  BANK_GESTOR_EDITAIS = 12,
  BANK_GESTOR_CREDENCIADO = 13,
  BANK_RESPONSAVEL_TECNICO = 14,
  BANK_OPERADOR = 15,
  BANK_APENAS_LEITURA = 16,
  JURIDICO = 17,
  CS = 18,
}

export const convertProfileUsers = (profileUsers: ProfileUsers): string => {
  let word: string;
  switch (profileUsers) {
    case ProfileUsers.SELECT:
      word = 'selecione uma opção';
      break;
    case ProfileUsers.ARCHITECT:
      word = 'arquiteto';
      break;
    case ProfileUsers.ENGINEER:
      word = 'engenheiro';
      break;
    case ProfileUsers.ADMIN:
      word = 'admin';
      break;
    case ProfileUsers.CORPORATE:
      word = 'corporate';
      break;
    case ProfileUsers.BANCO:
      word = 'banco';
      break;
    case ProfileUsers.LANDING:
      word = 'landing';
      break;
    case ProfileUsers.COMERCIAL:
      word = 'comercial';
      break;
    case ProfileUsers.FINANCEIRO:
      word = 'financeiro';
      break;
    case ProfileUsers.CORRETOR:
      word = 'corretor';
      break;
    case ProfileUsers.BANK_ADMIN:
      word = 'admin do banco';
      break;
    case ProfileUsers.BANK_FINANCEIRO:
      word = 'financeiro do banco';
      break;
    case ProfileUsers.BANK_GESTOR_EDITAIS:
      word = 'gestor de editais';
      break;
    case ProfileUsers.BANK_GESTOR_CREDENCIADO:
      word = 'gestor do credenciado';
      break;
    case ProfileUsers.BANK_RESPONSAVEL_TECNICO:
      word = 'responsável técnico';
      break;
    case ProfileUsers.BANK_OPERADOR:
      word = 'operador';
      break;
    case ProfileUsers.BANK_APENAS_LEITURA:
      word = 'apenas leitura';
      break;
    case ProfileUsers.JURIDICO:
      word = 'jurídico';
      break;
    case ProfileUsers.CS:
      word = 'cs';
      break;
    default:
      word = '';
  }
  return word;
};

export enum BankAdditionalRoles {
  SELECT,
  BANK_ADMIN = 10,
  BANK_FINANCE = 11,
  BANK_NOTICE_MANAGER = 12,
  BANK_LICENSED_MANAGER = 13,
  BANK_TECHNICAL_RESPONSIBLE = 14,
  BANK_OPERATOR = 15,
  BANK_READ_ONLY = 16,
  JURIDICO = 17,
  CS = 18,
}

export const convertBankAdditionalRoles = (
  bankAdditionalRoles: BankAdditionalRoles
): string => {
  let word: string;
  switch (bankAdditionalRoles) {
    case BankAdditionalRoles.SELECT:
      word = 'selecione uma opção';
      break;
    case BankAdditionalRoles.BANK_ADMIN:
      word = 'admin';
      break;
    case BankAdditionalRoles.BANK_FINANCE:
      word = 'financeiro';
      break;
    case BankAdditionalRoles.BANK_NOTICE_MANAGER:
      word = 'gestor de editais';
      break;
    case BankAdditionalRoles.BANK_LICENSED_MANAGER:
      word = 'gestor do credenciado';
      break;
    case BankAdditionalRoles.BANK_TECHNICAL_RESPONSIBLE:
      word = 'responsável técnico';
      break;
    case BankAdditionalRoles.BANK_OPERATOR:
      word = 'operador';
      break;
    case BankAdditionalRoles.BANK_READ_ONLY:
      word = 'apenas leitura';
      break;
    case BankAdditionalRoles.JURIDICO:
      word = 'jurídico';
      break;
    case BankAdditionalRoles.CS:
      word = 'cs';
      break;
    default:
      word = '';
  }
  return word;
};

export enum PropertyType {
  SELECT,
  APARTMENT = 1,
  HOUSE = 2,
  STORE = 4,
  LOT = 5,
  SHED = 7,
  COMMERCIAL_BUILDING = 15,
  COMMERCIAL_SPACE = 16,
}

export const convertPropertyType = (enumType: PropertyType): string => {
  let word: string;
  switch (enumType) {
    case PropertyType.SELECT:
      word = 'selecione uma opção';
      break;
    case PropertyType.APARTMENT:
      word = 'apartamento';
      break;
    case PropertyType.HOUSE:
      word = 'casa';
      break;
    case PropertyType.STORE:
      word = 'loja';
      break;
    case PropertyType.LOT:
      word = 'terreno/lote';
      break;
    case PropertyType.SHED:
      word = 'galpão';
      break;
    case PropertyType.COMMERCIAL_BUILDING:
      word = 'prédio comercial ';
      break;
    case PropertyType.COMMERCIAL_SPACE:
      word = 'sala comercial';
      break;
    default:
      word = '';
  }
  return word;
};

export enum PropertyUse {
  SELECT,
  RESIDENCIAL,
  COMERCIAL,
  INDUSTRIAL,
  INSTITUTIONAL,
  MIXED,
}

export const convertPropertyUse = (enumType: PropertyUse): string => {
  let word: string;
  switch (enumType) {
    case PropertyUse.SELECT:
      word = 'selecione uma opção';
      break;
    case PropertyUse.RESIDENCIAL:
      word = 'residencial';
      break;
    case PropertyUse.COMERCIAL:
      word = 'comercial';
      break;
    case PropertyUse.INDUSTRIAL:
      word = 'industrial';
      break;
    case PropertyUse.INSTITUTIONAL:
      word = 'institucional';
      break;
    case PropertyUse.MIXED:
      word = 'misto';
      break;
    default:
      word = '';
  }
  return word;
};

export enum QuestionType {
  SELECT,
  SHORT_ANSWER,
  SINGLE_SELECTION,
  MULTIPLE_CHOICE,
  LIST,
  DATE,
  NUMERIC,
}

export const convertQuestionType = (enumType: QuestionType): string => {
  let word: string;
  switch (enumType) {
    case QuestionType.SELECT:
      word = 'selecione uma opção';
      break;
    case QuestionType.SHORT_ANSWER:
      word = 'resposta curta';
      break;
    case QuestionType.SINGLE_SELECTION:
      word = 'seleção única';
      break;
    case QuestionType.MULTIPLE_CHOICE:
      word = 'múltipla escolha';
      break;
    case QuestionType.LIST:
      word = 'lista suspensa';
      break;
    case QuestionType.DATE:
      word = 'data';
      break;
    case QuestionType.NUMERIC:
      word = 'resposta numérica';
      break;
    default:
      word = '';
  }
  return word;
};

export enum RegistrationUf {
  SELECT,
  AC,
  AL,
  AP,
  AM,
  BA,
  CE,
  DF,
  ES,
  GO,
  MA,
  MT,
  MS,
  MG,
  PA,
  PB,
  PR,
  PE,
  PI,
  RJ,
  RN,
  RS,
  RO,
  RR,
  SC,
  SP,
  SE,
  TO,
}

export const convertRegistrationUf = (enumType: RegistrationUf): string => {
  let word: string;
  switch (enumType) {
    case RegistrationUf.SELECT:
      word = 'selecione uma opção';
      break;
    case RegistrationUf.AC:
      word = 'AC';
      break;
    case RegistrationUf.AL:
      word = 'AL';
      break;
    case RegistrationUf.AP:
      word = 'AP';
      break;
    case RegistrationUf.AM:
      word = 'AM';
      break;
    case RegistrationUf.BA:
      word = 'BA';
      break;
    case RegistrationUf.CE:
      word = 'CE';
      break;
    case RegistrationUf.DF:
      word = 'DF';
      break;
    case RegistrationUf.ES:
      word = 'ES';
      break;
    case RegistrationUf.GO:
      word = 'GO';
      break;
    case RegistrationUf.MA:
      word = 'MA';
      break;
    case RegistrationUf.MT:
      word = 'MT';
      break;
    case RegistrationUf.MS:
      word = 'MS';
      break;
    case RegistrationUf.MG:
      word = 'MG';
      break;
    case RegistrationUf.PA:
      word = 'PA';
      break;
    case RegistrationUf.PB:
      word = 'PB';
      break;
    case RegistrationUf.PR:
      word = 'PR';
      break;
    case RegistrationUf.PE:
      word = 'PE';
      break;
    case RegistrationUf.PI:
      word = 'PI';
      break;
    case RegistrationUf.RJ:
      word = 'RJ';
      break;
    case RegistrationUf.RN:
      word = 'RN';
      break;
    case RegistrationUf.RS:
      word = 'RS';
      break;
    case RegistrationUf.RO:
      word = 'RO';
      break;
    case RegistrationUf.RR:
      word = 'RR';
      break;
    case RegistrationUf.SC:
      word = 'SC';
      break;
    case RegistrationUf.SP:
      word = 'SP';
      break;
    case RegistrationUf.SE:
      word = 'SE';
      break;
    case RegistrationUf.TO:
      word = 'TO';
      break;
    default:
      word = '';
  }
  return word;
};

export const ufAbbreviation: Record<RegistrationUf, string> = {
  [RegistrationUf.SELECT]: 'selecione',
  [RegistrationUf.AC]: 'AC',
  [RegistrationUf.AL]: 'AL',
  [RegistrationUf.AP]: 'AP',
  [RegistrationUf.AM]: 'AM',
  [RegistrationUf.BA]: 'BA',
  [RegistrationUf.CE]: 'CE',
  [RegistrationUf.DF]: 'DF',
  [RegistrationUf.ES]: 'ES',
  [RegistrationUf.GO]: 'GO',
  [RegistrationUf.MA]: 'MA',
  [RegistrationUf.MT]: 'MT',
  [RegistrationUf.MS]: 'MS',
  [RegistrationUf.MG]: 'MG',
  [RegistrationUf.PA]: 'PA',
  [RegistrationUf.PB]: 'PB',
  [RegistrationUf.PR]: 'PR',
  [RegistrationUf.PE]: 'PE',
  [RegistrationUf.PI]: 'PI',
  [RegistrationUf.RJ]: 'RJ',
  [RegistrationUf.RN]: 'RN',
  [RegistrationUf.RS]: 'RS',
  [RegistrationUf.RO]: 'RO',
  [RegistrationUf.RR]: 'RR',
  [RegistrationUf.SC]: 'SC',
  [RegistrationUf.SP]: 'SP',
  [RegistrationUf.SE]: 'SE',
  [RegistrationUf.TO]: 'TO',
};

export const ufAbbreviationToEnum = Object.fromEntries(
  Object.entries(ufAbbreviation).map(([key, value]) => [value, Number(key)])
) as Record<string, RegistrationUf>;

export enum ReportGoal {
  SELECT,
  MARKET_BUY,
  MARKET_TENANCY,
  REEDITION,
  LIQUIDATION,
  OTHERS,
}

export const convertReportGoal = (reportGoal: ReportGoal): string => {
  let word = '';
  switch (reportGoal) {
    case ReportGoal.SELECT:
      word = 'selecione uma opção';
      break;
    case ReportGoal.MARKET_BUY:
      word = 'valor de mercado de compra e venda';
      break;
    case ReportGoal.MARKET_TENANCY:
      word = 'valor de mercado de locação';
      break;
    case ReportGoal.REEDITION:
      word = 'custo de reedição';
      break;
    case ReportGoal.LIQUIDATION:
      word = 'valor de liquidação forçada';
      break;
    case ReportGoal.OTHERS:
      word = 'outros';
      break;
    default:
      word = '';
  }
  return word;
};

export enum ReportFunction {
  SELECT,
  TENANCY,
  LEASE,
  LENDING,
  ACQUISITION,
  DONATION,
  ALIENATION,
  GIVING_PAYMENT,
  EXCHANGE,
  GUARANTEE,
  ACCOUNTING,
  INSURANCE,
  AUCTION,
  ADJUDICATION,
  REPARATION,
  TAXATION,
  JUDICIAL,
  EXTRA_JUDICIAL,
  PRE_AUCTION,
  OTHERS,
}

export const convertReportFunction = (
  reportFunction: ReportFunction
): string => {
  let word = '';
  switch (reportFunction) {
    case ReportFunction.SELECT:
      word = 'selecione uma opção';
      break;
    case ReportFunction.TENANCY:
      word = 'locação';
      break;
    case ReportFunction.LEASE:
      word = 'arrendamento';
      break;
    case ReportFunction.LENDING:
      word = 'comodato';
      break;
    case ReportFunction.ACQUISITION:
      word = 'aquisição';
      break;
    case ReportFunction.DONATION:
      word = 'doação';
      break;
    case ReportFunction.ALIENATION:
      word = 'alienação';
      break;
    case ReportFunction.GIVING_PAYMENT:
      word = 'dação em pagamento';
      break;
    case ReportFunction.EXCHANGE:
      word = 'permuta';
      break;
    case ReportFunction.GUARANTEE:
      word = 'garantia';
      break;
    case ReportFunction.ACCOUNTING:
      word = 'fins contábeis';
      break;
    case ReportFunction.INSURANCE:
      word = 'seguro';
      break;
    case ReportFunction.AUCTION:
      word = 'arrematação';
      break;
    case ReportFunction.ADJUDICATION:
      word = 'adjudicação';
      break;
    case ReportFunction.REPARATION:
      word = 'indenização';
      break;
    case ReportFunction.TAXATION:
      word = 'tributação';
      break;
    case ReportFunction.EXTRA_JUDICIAL:
      word = 'extrajudicial';
      break;
    case ReportFunction.JUDICIAL:
      word = 'judicial';
      break;
    case ReportFunction.PRE_AUCTION:
      word = 'leilão';
      break;
    case ReportFunction.OTHERS:
      word = 'outros';
      break;
    default:
      word = '';
  }
  return word;
};

export enum ReportSource {
  ELEMENT = 1,
  REPORT,
}

export const convertReportSource = (enumType: ReportSource): string => {
  let word: string;
  switch (enumType) {
    case ReportSource.ELEMENT:
      word = 'elemento';
      break;
    case ReportSource.REPORT:
      word = 'relatório';
      break;
    default:
      word = '';
  }
  return word;
};

export enum Standard {
  SELECT,
  SIMPLE,
  NORMAL,
  HIGH,
}

export const convertStandard = (enumType: Standard): string => {
  let word: string;
  switch (enumType) {
    case Standard.SELECT:
      word = 'selecione uma opção';
      break;
    case Standard.SIMPLE:
      word = 'simples';
      break;
    case Standard.NORMAL:
      word = 'normal';
      break;
    case Standard.HIGH:
      word = 'alto';
      break;
    default:
      word = '';
  }
  return word;
};

export const convertStandard400K = (enumType: Standard): string => {
  let word: string;
  switch (enumType) {
    case Standard.SELECT:
      word = 'selecione uma opção';
      break;
    case Standard.SIMPLE:
      word = 'normal';
      break;
    case Standard.NORMAL:
      word = 'superior';
      break;
    case Standard.HIGH:
      word = 'fino';
      break;
    default:
      word = '';
  }
  return word;
};

export enum Status {
  ENTRANCE = 1,
  SCHEDULE,
  INSPECTION,
  SAMPLE_CREATION,
  CALCULATION,
  REPORT,
  REVISION,
  ARCHIVED,
  PEPT = 9,
}

export const convertStatus = (enumType: Status): string => {
  let word: string;
  switch (enumType) {
    case Status.ENTRANCE:
      word = 'entrada';
      break;
    case Status.SCHEDULE:
      word = 'agendamento';
      break;
    case Status.INSPECTION:
      word = 'em vistoria';
      break;
    case Status.SAMPLE_CREATION:
      word = 'criação de amostra';
      break;
    case Status.CALCULATION:
      word = 'processando cálculo';
      break;
    case Status.REPORT:
      word = 'elaboração de laudo';
      break;
    case Status.REVISION:
      word = 'revisão e aprovação';
      break;
    case Status.ARCHIVED:
      word = 'arquivado';
      break;
    case Status.PEPT:
      word = 'pendência técnica';
      break;
    default:
      word = '';
  }
  return word;
};

export const convertStatusUrl = (enumType: Status): string => {
  let word: string;
  switch (enumType) {
    case Status.ENTRANCE:
      word = 'edit';
      break;
    case Status.SCHEDULE:
      word = 'schedule';
      break;
    case Status.INSPECTION:
      word = 'inspection';
      break;
    case Status.SAMPLE_CREATION:
      word = 'sample';
      break;
    case Status.REPORT:
      word = 'report';
      break;
    case Status.REVISION:
      word = 'revision';
      break;
    case Status.PEPT:
      word = 'pept';
      break;
    case Status.CALCULATION:
      word = 'calculation';
      break;
    case Status.ARCHIVED:
      word = 'archived';
      break;
    default:
      word = '';
  }
  return word;
};

export enum StatusCode {
  OK = 0,
  ERROR = 3,
  NOT_FOUND = 4,
  PROCESSING = 5,
}

export enum YesOrNo {
  SELECT,
  YES,
  NO,
}

export const convertYesOrNo = (enumType: YesOrNo): string => {
  let word: string;
  switch (enumType) {
    case YesOrNo.SELECT:
      word = 'selecione uma opção';
      break;
    case YesOrNo.YES:
      word = 'sim';
      break;
    case YesOrNo.NO:
      word = 'não';
      break;
    default:
      word = '';
  }
  return word;
};

export enum WebsocketTypes {
  AVM_PROCESSED = 'avm-processed',
  NEW_MESSAGE = 'unread-hive-messages-count',
  DELEGATED_ACCESS_STATUS_UPDATE = 'delegated_access_status_update',
}

export enum InspectionType {
  SELECT,
  IN_PERSON,
  REMOTE,
  NO_INSPECTION,
}

export const convertInspectionType = (
  inspectionType: InspectionType
): string => {
  let word: string;
  switch (inspectionType) {
    case InspectionType.SELECT:
      word = 'selecione uma opção';
      break;
    case InspectionType.IN_PERSON:
      word = 'presencial';
      break;
    case InspectionType.REMOTE:
      word = 'vistoria por videoconferência';
      break;
    case InspectionType.NO_INSPECTION:
      word = 'sem vistoria';
      break;
    default:
      word = '';
  }
  return word;
};

export enum NoticeAttachmentType {
  DOC = 1,
  LINK,
  ATT,
}

export enum DocumentStatus {
  PENDING = 1,
  UNDER_ANALYSIS,
  APPROVED,
  REJECTED,
  CANCELED,
  REPLACEMENT_REQUEST,
}

export const convertDocumentStatus = (docStatus: DocumentStatus): string => {
  let word: string;
  switch (docStatus) {
    case DocumentStatus.PENDING:
      word = 'pendente';
      break;
    case DocumentStatus.UNDER_ANALYSIS:
      word = 'em análise';
      break;
    case DocumentStatus.APPROVED:
      word = 'aprovado';
      break;
    case DocumentStatus.REJECTED:
      word = 'rejeitado';
      break;
    case DocumentStatus.CANCELED:
      word = 'cancelado';
      break;
    case DocumentStatus.REPLACEMENT_REQUEST:
      word = 'substituição solicitada';
      break;
    default:
      word = '';
  }
  return word;
};

export enum SelectDocumentCategory {
  LEGAL = 1,
  TECHNICAL,
  PROFESSIONAL = 4,
}

export const convertDocumentCategory = (
  docCategory: SelectDocumentCategory
): string => {
  let word: string;
  switch (docCategory) {
    case SelectDocumentCategory.LEGAL:
      word = 'análise jurídica';
      break;
    case SelectDocumentCategory.TECHNICAL:
      word = 'análise técnica da Pessoa Jurídica';
      break;
    case SelectDocumentCategory.PROFESSIONAL:
      word = 'análise técnica do profissional';
      break;
    default:
      word = '';
  }
  return word;
};

export enum DocumentCategory {
  LEGAL = 1,
  TECHNICAL,
  BB,
  PROFESSIONAL,
  OTHER,
}

export enum NoticeDocumentType {
  CNPJ = 1,
  EMPRESARIO,
  CONTRATO_SOCIAL,
  ESTATUTO_SOCIAL,
  ATA_CONSTITUICAO,
  REGISTRO_CARTORIO,
  ATO_CONSTITUTIVO,
  CERTIDAO_JUNTA,
  REGISTRO_JUNTA,
  CERTIDAO_QUITACAO_CREA_CAU,
  INSCRICAO_CREA_CAU,
  CERTIDAO_RESP_TEC,
  RG,
  VINCULO_EMPRESA,
  REGISTRO_CREA_CAU,
  CURSOS_NBR,
  ART_RRT,
  ACERVO_TEC,
  AVALIACOES_AA,
  CAT_CREA_CAU,
  LAUDO_ABNT,
  CPF,
  ENS_SUP,
  AVALIACAO_IMOVEIS,
  CADASTRO_ESTADUAL_OU_MUNICIPAL,
  CREDENCIAMENTO_CAIXA_BB,
  CONTRATO_PRESTACAO_SERVICOS,
  OTHERS,
}

export enum HiveRequestAcceptanceStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  ACCEPTED_WITH_PENDING = 'accepted_with_pendency',
  REJECTED = 'rejected',
}

export enum NoticeCriteriaGroupActivity {
  SELECT = 0,
  URBAN = 1,
  RURAL = 2,
}

export const convertCriteriaGroupActivity = (
  docCategory: NoticeCriteriaGroupActivity
): string => {
  let word: string;
  switch (docCategory) {
    case NoticeCriteriaGroupActivity.SELECT:
      word = 'selecione uma opção';
      break;
    case NoticeCriteriaGroupActivity.URBAN:
      word = 'urbano';
      break;
    case NoticeCriteriaGroupActivity.RURAL:
      word = 'rural';
      break;
    default:
      word = '';
  }
  return word;
};

export enum CompanyDocumentType {
  CPF = 0,
  CNPJ = 1,
}

export const convertCompanyDocumentType = (
  enumType: CompanyDocumentType
): string => {
  let word: string;
  switch (enumType) {
    case CompanyDocumentType.CPF:
      word = 'CPF';
      break;
    case CompanyDocumentType.CNPJ:
      word = 'CNPJ';
      break;
    default:
      word = '';
  }
  return word;
};

export enum RegisterStage {
  PASSWORD,
  AUTH_METHOD,
  CONFIRMATION_AUTH_METHOD,
}

export const convertRegisterStage = (enumType: RegisterStage): string => {
  let word: string;
  switch (enumType) {
    case RegisterStage.PASSWORD:
      word = 'Criar senha';
      break;
    case RegisterStage.AUTH_METHOD:
      word = '';
      break;
    case RegisterStage.CONFIRMATION_AUTH_METHOD:
      word = '';
      break;
    default:
      word = '';
  }
  return word;
};

export enum SlaStatus {
  ON_TRACK = 'on_track',
  NEAR_DEADLINE = 'near_deadline',
  OVERDUE = 'overdue',
}

export enum HiveAssignmentType {
  MANUAL = 'manual',
  AUTOMATIC = 'automatic',
}

export enum PaymentStatus {
  SELECT,
  PENDING,
  APPROVED,
  INVOICED,
  PAID,
  CANCELLED,
  REFUNDED,
}

export const convertPaymentStatus = (paymentStatus: PaymentStatus): string => {
  let word: string;
  switch (paymentStatus) {
    case PaymentStatus.SELECT:
      word = 'selecione uma opção';
      break;
    case PaymentStatus.PENDING:
      word = 'pendente';
      break;
    case PaymentStatus.APPROVED:
      word = 'aprovado';
      break;
    case PaymentStatus.INVOICED:
      word = 'faturado';
      break;
    case PaymentStatus.PAID:
      word = 'pago';
      break;
    case PaymentStatus.CANCELLED:
      word = 'cancelado';
      break;
    case PaymentStatus.REFUNDED:
      word = 'estornado';
      break;
    default:
      word = '';
  }
  return word;
};

export enum CalculationStrategy {
  SELECT,
  INFERENCE,
  FACTORS,
  INVOLUTIVE,
  EVOLUTIVE,
}

export const convertCalculationStrategy = (
  calculation: CalculationStrategy
): string => {
  let word: string;
  switch (calculation) {
    case CalculationStrategy.SELECT:
      word = 'selecione uma opção';
      break;
    case CalculationStrategy.INFERENCE:
      word = 'inferência';
      break;
    case CalculationStrategy.FACTORS:
      word = 'fatores';
      break;
    case CalculationStrategy.INVOLUTIVE:
      word = 'involutivo';
      break;
    case CalculationStrategy.EVOLUTIVE:
      word = 'evolutivo';
      break;
    default:
      word = '';
  }
  return word;
};

export enum ReportMode {
  SELECT,
  SIMPLIFIED,
  COMPLETE,
}

export const convertReportMode = (report: ReportMode): string => {
  let word: string;
  switch (report) {
    case ReportMode.SELECT:
      word = 'selecione uma opção';
      break;
    case ReportMode.SIMPLIFIED:
      word = 'simplificado';
      break;
    case ReportMode.COMPLETE:
      word = 'completo';
      break;
    default:
      word = '';
  }
  return word;
};
